import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyParticolariService {
    static getTipi = (id_azienda = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/tipi`;
            ApiService.postRequest(resolve, reject, url, id_azienda ? { id_azienda } : {});
        });
    };

    static byAzienda = (id_azienda, soloAttivi = false) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/byAzienda`;
            ApiService.postRequest(resolve, reject, url, {
                id_azienda,
                solo_attivi: soloAttivi ? 1 : 0,
            });
        });
    };

    static stats = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/stats`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/create`;
        return ApiService.postFormData(url, formData);
    };

    static update = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/update`;
        return ApiService.postFormData(url, formData);
    };

    static delete = (id_particolare) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/delete`;
            ApiService.postRequest(resolve, reject, url, { id_particolare });
        });
    };

    static download = (id_particolare, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/particolari/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_particolare, filename });
        });
    };
}
